// src/utils/anonymizeUtils.ts
/**
* Masks the local part of an email for safe logging; domain unchanged.
*
* - Empty / invalid local: `***@domain`
* - 1 character: `*@domain` (fully masked)
* - 2 characters: first character + `*` (e.g. `a*@domain`)
* - 3 characters: first character + `**` (e.g. `a**@domain`)
* - 4+ characters: first + `*` per middle character + last (e.g. `j**n@domain`)
*/
function anonymizeEmail(email) {
	const trimmed = email.trim();
	const at = trimmed.lastIndexOf("@");
	if (at <= 0 || at === trimmed.length - 1) return "***";
	const local = trimmed.slice(0, at);
	const domain = trimmed.slice(at + 1);
	if (local.length === 0) return `***@${domain}`;
	if (local.length === 1) return `*@${domain}`;
	if (local.length === 2) return `${local[0]}*@${domain}`;
	if (local.length === 3) return `${local[0]}**@${domain}`;
	const first = local[0];
	const last = local[local.length - 1];
	return `${first}${"*".repeat(local.length - 2)}${last}@${domain}`;
}
/** Typical email shape in ASCII error strings (local@host.tld, TLD at least 2 chars). */
const EMAIL_LIKE_PATTERN = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;
/**
* Replaces substrings that look like email addresses with {@link anonymizeEmail} output.
* Use when logging arbitrary error messages that might embed user emails.
*/
function anonymizeEmailsInString(text) {
	return text.replace(EMAIL_LIKE_PATTERN, (match) => anonymizeEmail(match));
}

export { anonymizeEmail, anonymizeEmailsInString };
//# sourceMappingURL=anonymizeUtils.mjs.map